// src/contexts/LayoutContext.tsx
import React, { createContext, useContext, useState, ReactNode } from 'react';
interface LayoutContextType {
  sidebarVisible: boolean;
  setSidebarVisible: (visible: boolean) => void;
  sidebarOpen: boolean;
  setSidebarOpen: (open: boolean) => void;
}
const LayoutContext = createContext<LayoutContextType | undefined>(undefined);
export const useLayout = () => {
  const context = useContext(LayoutContext);
  if (context === undefined) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
};
interface LayoutProviderProps {
  children: ReactNode;
}
export const LayoutProvider: React.FC<LayoutProviderProps> = ({
  children
}) => {
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  return <LayoutContext.Provider value={{
    sidebarVisible,
    setSidebarVisible,
    sidebarOpen,
    setSidebarOpen
  }}>
      {children}
    </LayoutContext.Provider>;
};